import { Component, OnDestroy, OnInit } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { BeerDetailPage } from '../../pages/beer-detail/beer-detail';
import { BeerServiceProvider } from '../../providers/beer-service/beer-service';
import { BeerProfileRequest, Venue } from "../../models/models";
import { LocationServiceProvider } from '../../providers/location-service/location-service';
import { UserDataProvider } from '../../providers/user-data/user-data';
import { RefdataProvider } from '../../providers/refdata/refdata'
import { BhutilProvider } from '../../providers/bhutil/bhutil';
import { AnalysisHolderProvider } from '../../providers/analysis-holder/analysis-holder';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage-angular';
import { AppEventService } from '../../app/app-events';
import { Router } from '@angular/router'
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'similar-beers',
  templateUrl: 'similar-beers.html',
  styleUrls: ['./similar-beers.scss'],
  standalone: false,
  // imports: [
  //   IonicModule,
  //   CommonModule,
  //   FormsModule,
  //   TranslateModule
  // ]
})
export class SimilarBeersComponent implements OnInit, OnDestroy {

  public beers: Array<any>;
  private similarBeersSubscription: any;
  venueSelectedSubscription: any;
  venueDeselectedSubscription: any;

  public selectedVenue: Venue = null;
  public changingVenue: boolean = false;

  constructor(
    private events: AppEventService,
    private refdata: RefdataProvider,
    private bhutil: BhutilProvider,
    private analysisHolder: AnalysisHolderProvider,
    private alertCtrl: AlertController,
    private translateService: TranslateService,
    private userData: UserDataProvider,
    private storage: Storage
  ) {
    //nothing needed besides adding the event listener
    // Load venue
    this.userData.init().then(() => {
/*
      this.storage.get('selected-venue').then((venue) => {
        // First read the selected venue from storage
        let venueJSON = JSON.parse(venue);
        if (venueJSON != null) {
          this.selectedVenue = venueJSON;
          console.log("similar-beers - currently venue with id selected: " + venueJSON.id);
        }
      });

      //any was Array<any>
      this.venueSelectedSubscription = (venue: Venue) => {
        console.log("similar-beers - noticed filter veneu changed to:", venue.id);
        this.selectedVenue = venue;
        this.changingVenue = true;
      };
      this.events.subscribe("venue:selected", this.venueSelectedSubscription);

      this.venueDeselectedSubscription = () => {
        console.log("similar-beers - noticed filter veneu changed to: null");
        this.selectedVenue = null;
        this.changingVenue = true;
      };
      this.events.subscribe("venue:deselected", this.venueDeselectedSubscription);
*/
    });
  }

  ngOnInit(): void {
      this.similarBeersSubscription = (similarbeers: any) => {
        console.log("[similar-beers] similarBeersSubscription called")
        this.beers = similarbeers;
        this.changingVenue = false;
      };
      this.events.subscribe("similarbeers", this.similarBeersSubscription);
  }

  showBeerDetail(b: any) {
    // TODO incorporate with ionViewCanLeave in beer-detail.ts
    if (this.analysisHolder.localChangeDetected) {
      console.log("save pending, inform user");
      let alertProm = this.alertCtrl.create({
        header: this.translateService.instant("OPENPAGE.YOUR_CURRENT_ANALYSIS_HAS_NOT_BEEN_SAVED_YET"),
        message: this.translateService.instant("OPENPAGE.DO_YOU_WANT_TO_SAVE_IT_NOW"),
        backdropDismiss: false,
        buttons: [
          {
            text: this.translateService.instant("OPENPAGE.YES_SAVE_AND_CLOSE_ANALYSIS"),
            handler: () => {
              console.log('Yes clicked');

              // save the pending analysis
              this.events.publish("save:beer");

              // after this, still show the similar beer to the user
              setTimeout(() => {
                console.log("TODO: show details for beer " + this.bhutil.stringify(b));
                console.log("beerID is " + b.id);

                this.events.publish("similar-beers:show:beer-analysis", b);
                this.events.publish("similar-beers:show:beer-info", b);
              }, 500);

            }
          },
          {
            text: this.translateService.instant("OPENPAGE.NO_CLOSE_ANALYSIS_WITHOUT_SAVING"),
            /*role: 'cancel',*/
            handler: () => {
              console.log('No clicked');
              this.analysisHolder.cancelPendingSave();
              // show the similar beer the user clicked on
              console.log("TODO: show details for beer " + this.bhutil.stringify(b));
              console.log("beerID is " + b.id);

              this.events.publish("similar-beers:show:beer-analysis", b);
              this.events.publish("similar-beers:show:beer-info", b);
            }
          },
          {
            text: this.translateService.instant("OPENPAGE.CANCEL_RETURN_TO_CURRENT_ANALYSIS"),
            role: 'cancel',
            handler: () => {
              console.log('Cancel clicked');
              console.log("[beer-hive-logo] Cancel clicked, nothing to do ...");
            }
          }
        ]
      });
      alertProm.then((alert) => alert.present() );
    }
    else {
      console.log("nothing to ask the user...");

      console.log("TODO: show details for beer " + this.bhutil.stringify(b));
      console.log("beerID is " + b.id);

      this.events.publish("similar-beers:show:beer-analysis", b);
      this.events.publish("similar-beers:show:beer-info", b);
    }

  }

  getImageUrl(b: any) {
    // console.log("[similar-beers] getImageUrl() - getImageUrl for beer id: " + b.id);

    //debugger;

    if (b.brewery === undefined) {
      //debugger;
      console.log("no brewery info found...");
    }

    if (b.logo !== undefined && b.logo != null) {
      let logoUrlBeer = this.refdata.getEnvVar('beerLogoBaseUrl') + b.logo;
      //console.log("LOGO - using beer logo: " + logoUrlBeer);
      return logoUrlBeer;
    } else if (b.brewery.logo !== undefined && b.brewery.logo != null) {
      //beer.logoUrl = "http://beerhiveb2bweb.qxhqfefni2.eu-west-1.elasticbeanstalk.com/assets/images/nologo.png";
      let logoUrlBrewery = this.refdata.getEnvVar('breweryLogoBaseUrl') + b.brewery.logo;
      //console.log("LOGO - using brewery logo: " + logoUrlBrewery);
      return logoUrlBrewery;
    }
    else {
      let logoNoLogo = "../assets/svg/icon_beerglass.svg";
      //console.log("LOGO - using placeholder logo (no_logo: " + logoNoLogo);
      return logoNoLogo;
    }
  }

  ngOnDestroy() {
    this.events.unsubscribe("similarbeers", this.similarBeersSubscription);
/*
    this.events.unsubscribe("venue:deselected", this.venueDeselectedSubscription);
    this.events.unsubscribe("venue:selected", this.venueSelectedSubscription);
*/
  }


}
